<template>
	<div>
		<div class="font-bold lg:text-right">
			<div class="flex justify-between lg:justify-end items-center">
				<div class="lg:hidden">Anzahl:</div>
				<div class="lg:text-right font-normal lg:font-bold">{{ item.quantity }}</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{ 
	item: OrderItem;
}>()
</script>
